import { createContext, useContext, useState, useCallback } from "react";

type Props = {
  children: React.ReactNode;
  notificationTimeout?: number;
};

type TroubleshootDetails = {
  aiExperimentName: string;
  guidanceOpened: boolean;
  predictionId: string;
};

type RunStepTroubleshootDetailContextType = {
  details: TroubleshootDetails;
  setDetails: (details: TroubleshootDetails) => void;
};

const defaultContext = {
  details: {
    aiExperimentName: "",
    guidanceOpened: false,
    predictionId: "",
  },
  setDetails: () => {
    // noop
  },
};

export const RunStepTroubleshootDetailContext =
  createContext<RunStepTroubleshootDetailContextType>(defaultContext);

export function useRunStepTroubleshootDetailContext() {
  return useContext(RunStepTroubleshootDetailContext);
}

export function RunStepTroubleshootDetailContextProvider({ children }: Props) {
  const [aiTroubleshootingDetails, setAiTroubleshootingDetails] =
    useState<TroubleshootDetails>({
      aiExperimentName: "",
      guidanceOpened: false,
      predictionId: "",
    });

  const setRunStepTroubleshootDetails = useCallback(
    (details: TroubleshootDetails) => {
      setAiTroubleshootingDetails(details);
    },
    []
  );

  return (
    <RunStepTroubleshootDetailContext.Provider
      value={{
        details: aiTroubleshootingDetails,
        setDetails: setRunStepTroubleshootDetails,
      }}
    >
      {children}
    </RunStepTroubleshootDetailContext.Provider>
  );
}
